import { render, staticRenderFns } from "./recoverPassword.vue?vue&type=template&id=f820c8c4&scoped=true"
import script from "./recoverPassword.vue?vue&type=script&lang=js"
export * from "./recoverPassword.vue?vue&type=script&lang=js"
import style0 from "./recoverPassword.vue?vue&type=style&index=0&id=f820c8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f820c8c4",
  null
  
)

export default component.exports